import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { isObservabilityEnabled } from '../config';
import { SentryInstance } from './instance';
SentryInstance.init({
  enabled: isObservabilityEnabled(),
  dsn: 'https://18e8e601f6352c29b414b11510564179@o4507699183353856.ingest.us.sentry.io/4507699185319936',
  integrations: [
    SentryInstance.browserTracingIntegration(),
    SentryInstance.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.copera\.ai/],
});
